import {
  faAddressBook,
  faFileAlt,
  faUser,
} from "@fortawesome/free-regular-svg-icons";
import { faB, faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link, NavLink } from "react-router-dom";

import { motion } from "framer-motion";

const Navbar = () => {
  const parentVariant = {
    hidden: {
      opacity: 0,
      scale: 0.8,
      y: -50,
    },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        delay: 0.2,
        duration: 1.5,
        ease: [0, 0.71, 0.2, 1.01],
      },
    },
  };
  return (
    <>
      <motion.header
        variants={parentVariant}
        initial="hidden"
        animate="visible"
        className="lg:w-[560px] h-[144px] hidden lg:block p-[30px] ml-auto mb-10 rounded-[16px] bg-b-drop"
      >
        <nav className="hidden lg:block">
          <ul className="flex">
            <li>
              <NavLink
                to={"/"}
                className="flex flex-col darkk:text-[#a6a6a6] font-semibold items-center justify-center rounded-[10px] text-[.8125rem]  w-20 h-20 bg-gray-200 darkk:bg-[#212425] mx-[0.625rem]  text-center hover:bg-gradient-to-r from-[#FA5252] to-[#DD2476] hover:text-white duration-300"
                href="#about"
              >
                {({ isActive }) => (
                  <span className={isActive ? "menu-active" : undefined}>
                    <FontAwesomeIcon className="text-xl mb-1" icon={faUser} />
                    <span className="block text-center">About</span>
                  </span>
                )}
              </NavLink>
            </li>
            <li>
              <NavLink
                to={"/resume"}
                className="flex flex-col darkk:text-[#a6a6a6] font-semibold items-center justify-center rounded-[10px] text-[.8125rem]  w-20 h-20 bg-gray-200 darkk:bg-[#212425] mx-[0.625rem]  text-center hover:bg-gradient-to-r from-[#FA5252] to-[#DD2476] hover:text-white duration-300"
                href="#about"
              >
                {({ isActive }) => (
                  <span className={isActive ? "menu-active" : undefined}>
                    <FontAwesomeIcon
                      className="text-xl mb-1"
                      icon={faBriefcase}
                    />
                    <span className="block text-center">Projects</span>
                  </span>
                )}
              </NavLink>
            </li>
            {/* TODO need to update something here on portfolio  */}
            {/* <li>
              <NavLink
                to={"/work"}
                className="flex flex-col darkk:text-[#a6a6a6] font-semibold items-center justify-center rounded-[10px] text-[.8125rem]  w-20 h-20 bg-gray-200 darkk:bg-[#212425] mx-[0.625rem]  text-center hover:bg-gradient-to-r from-[#FA5252] to-[#DD2476] hover:text-white duration-300"
                href="#works"
              >
                {({ isActive }) => (
                  <span className={isActive ? "menu-active" : undefined}>
                    <FontAwesomeIcon
                      className="text-xl mb-1"
                      icon={faBriefcase}
                    />
                    <span className="block text-center">Works</span>
                  </span>
                )}
              </NavLink>
            </li> */}
            <li>
              <NavLink
                to={"blogs"}
                className="flex flex-col darkk:text-[#a6a6a6] font-semibold items-center justify-center rounded-[10px] text-[.8125rem]  w-20 h-20 bg-gray-200 darkk:bg-[#212425] mx-[0.625rem]  text-center hover:bg-gradient-to-r from-[#FA5252] to-[#DD2476] hover:text-white duration-300"
                href="#blogs"
              >
                {({ isActive }) => (
                  <span className={isActive ? "menu-active" : undefined}>
                    <FontAwesomeIcon className="text-xl mb-1" icon={faB} />
                    <span className="block text-center">Blogs</span>
                  </span>
                )}
              </NavLink>
            </li>
            <li>
              <NavLink
                to={"/contact"}
                className="flex flex-col darkk:text-[#a6a6a6] font-semibold items-center justify-center rounded-[10px] text-[.8125rem]  w-20 h-20 bg-gray-200 darkk:bg-[#212425] mx-[0.625rem]  text-center hover:bg-gradient-to-r from-[#FA5252] to-[#DD2476] hover:text-white duration-300"
                href="#contact"
              >
                {({ isActive }) => (
                  <span className={isActive ? "menu-active" : undefined}>
                    <FontAwesomeIcon
                      className="text-xl mb-1"
                      icon={faAddressBook}
                    />
                    <span className="block text-center">Contact</span>
                  </span>
                )}
              </NavLink>
            </li>
            <li>
              <a
                className="flex flex-col darkk:text-[#a6a6a6] font-semibold items-center justify-center rounded-[10px] text-[.8125rem]  w-20 h-20 bg-gray-200 darkk:bg-[#212425] mx-[0.625rem]  text-center hover:bg-gradient-to-r from-[#FA5252] to-[#DD2476] hover:text-white duration-300"
                href="https://drive.google.com/file/d/1VzrnrfBzEtD5xwUsXeXQsST-HltP0Qaq/view?usp=sharing"
              >
                <span className="menu-active">
                  <FontAwesomeIcon className="text-xl mb-1" icon={faFileAlt} />
                  <span className="block text-center">Resume</span>
                </span>
              </a>
            </li>
          </ul>
        </nav>
      </motion.header>

      {/* ************
      mobile menu
       *********** */}
      <header className="mobile-navbar bg-[rgba(255,255,255,0.4)] backdrop-blur-[5px] w-full fixed z-10 lg:hidden shadow-md p-[16px] mb-6 overflow-x-scroll sm:overflow-visible">
        <nav className=" lg:hidden">
          <ul className="flex">
            <li>
              <NavLink
                to={"/"}
                className="flex flex-col darkk:text-[#a6a6a6] font-semibold items-center justify-center rounded-[10px] text-[.8125rem]  w-20 h-20 bg-gray-200 darkk:bg-[#212425] mx-[0.625rem]  text-center hover:bg-gradient-to-r from-[#FA5252] to-[#DD2476] hover:text-white duration-300"
                href="#about"
              >
                {({ isActive }) => (
                  <span className={isActive ? "menu-active" : undefined}>
                    <FontAwesomeIcon className="text-xl mb-1" icon={faUser} />
                    <span className="block text-center">About</span>
                  </span>
                )}
              </NavLink>
            </li>
            <li>
              <NavLink
                to={"/resume"}
                className="flex flex-col darkk:text-[#a6a6a6] font-semibold items-center justify-center rounded-[10px] text-[.8125rem]  w-20 h-20 bg-gray-200 darkk:bg-[#212425] mx-[0.625rem]  text-center hover:bg-gradient-to-r from-[#FA5252] to-[#DD2476] hover:text-white duration-300"
                href="#about"
              >
                {({ isActive }) => (
                  <span className={isActive ? "menu-active" : undefined}>
                    <FontAwesomeIcon
                      className="text-xl mb-1"
                      icon={faBriefcase}
                    />
                    <span className="block text-center">Projects</span>
                  </span>
                )}
              </NavLink>
            </li>
            {/* TODO need to update something here on portfolio  */}
            {/* <li>
              <NavLink
                to={"/work"}
                className="flex flex-col darkk:text-[#a6a6a6] font-semibold items-center justify-center rounded-[10px] text-[.8125rem]  w-20 h-20 bg-gray-200 darkk:bg-[#212425] mx-[0.625rem]  text-center hover:bg-gradient-to-r from-[#FA5252] to-[#DD2476] hover:text-white duration-300"
                href="#works"
              >
                {({ isActive }) => (
                  <span className={isActive ? "menu-active" : undefined}>
                    <FontAwesomeIcon
                      className="text-xl mb-1"
                      icon={faBriefcase}
                    />
                    <span className="block text-center">Works</span>
                  </span>
                )}
              </NavLink>
            </li> */}
            <li>
              <NavLink
                to={"blogs"}
                className="flex flex-col darkk:text-[#a6a6a6] font-semibold items-center justify-center rounded-[10px] text-[.8125rem]  w-20 h-20 bg-gray-200 darkk:bg-[#212425] mx-[0.625rem]  text-center hover:bg-gradient-to-r from-[#FA5252] to-[#DD2476] hover:text-white duration-300"
                href="#blogs"
              >
                {({ isActive }) => (
                  <span className={isActive ? "menu-active" : undefined}>
                    <FontAwesomeIcon className="text-xl mb-1" icon={faB} />
                    <span className="block text-center">Blogs</span>
                  </span>
                )}
              </NavLink>
            </li>
            <li>
              <NavLink
                to={"/contact"}
                className="flex flex-col darkk:text-[#a6a6a6] font-semibold items-center justify-center rounded-[10px] text-[.8125rem]  w-20 h-20 bg-gray-200 darkk:bg-[#212425] mx-[0.625rem]  text-center hover:bg-gradient-to-r from-[#FA5252] to-[#DD2476] hover:text-white duration-300"
                href="#contact"
              >
                {({ isActive }) => (
                  <span className={isActive ? "menu-active" : undefined}>
                    <FontAwesomeIcon
                      className="text-xl mb-1"
                      icon={faAddressBook}
                    />
                    <span className="block text-center">Contact</span>
                  </span>
                )}
              </NavLink>
            </li>
            <li>
              <a
                className="flex flex-col darkk:text-[#a6a6a6] font-semibold items-center justify-center rounded-[10px] text-[.8125rem]  w-20 h-20 bg-gray-200 darkk:bg-[#212425] mx-[0.625rem]  text-center hover:bg-gradient-to-r from-[#FA5252] to-[#DD2476] hover:text-white duration-300"
                href="https://drive.google.com/file/d/1VzrnrfBzEtD5xwUsXeXQsST-HltP0Qaq/view?usp=sharing"
              >
                <span className="menu-active">
                  <FontAwesomeIcon className="text-xl mb-1" icon={faFileAlt} />
                  <span className="block text-center">Resume</span>
                </span>
              </a>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
};

export default Navbar;
